/*
  VinZone — exact VIN fitment on the results page (13 Oct 2026).

  WHAT IT DOES
  After a VIN search the finder (assets/vz-vehicle-finder.js) keeps the decode in
  sessionStorage ('vz_vin_decode': chassis code, VIN serial, build plant, engine,
  wheelbase). The server has already filtered the collection on
  fits_make / fits_model / fits_year / fits_engine_code / fits_vin. This script
  then reads each card's custom.fits_epc (the JLR EPC where-used lines of the
  whole supersession chain: catalogue, From/To VIN, EPC page name, option) and
  hides every card that has no line matching THIS car:
    · same catalogue (L663, L494, X761 …),
    · VIN serial inside the From–To breakpoints (same plant character),
    · the page's plant / wheelbase / engine text agree with the decode.
  Lines that depend on an option the VIN cannot tell (brake size 18/20 in,
  air/coil suspension, SVR…) stay visible and get a badge; when two or more
  products of the same type remain with different options, a "Which one is
  yours?" strip is shown with the WhatsApp fallback.

  WHAT IT NEVER DOES
  No VIN decode in storage, no fits_* filter in the URL, or a card without
  fits_epc → nothing is hidden. It only ever hides cards that carry EPC data
  and demonstrably do not fit. Dawn's facets.js swaps #ProductGridContainer on
  every filter change, so the check re-runs on each swap.
*/
(function () {
  'use strict';

  var KEY = 'vz_vin_decode';
  var TTL = 6 * 60 * 60 * 1000;
  var ORDER = 'XY123456789ABCDEFGHJKLMNPRSTVW'; // VIN model-year letters in order
  var AR = (document.documentElement.lang || '').indexOf('ar') === 0;
  var WA = '971565950260';

  function decode() {
    try {
      var d = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      if (!d || !d.cat || !d.serial || Date.now() - (d.t || 0) > TTL) return null;
      return d;
    } catch (e) { return null; }
  }

  function vehicleFiltered() {
    var p = new URLSearchParams(window.location.search);
    var any = false;
    p.forEach(function (v, k) { if (k.indexOf('filter.p.m.custom.fits_') === 0) any = true; });
    return any;
  }

  function serialKey(s) {
    // 'L2005716' → [year index, number]
    var y = ORDER.indexOf(s.charAt(0));
    var n = parseInt(s.slice(2), 10);
    return [y < 0 ? 0 : y, isNaN(n) ? 0 : n];
  }
  function before(a, b) { return a[0] < b[0] || (a[0] === b[0] && a[1] < b[1]); }

  function inRange(serial, e) {
    var f = e.from_vin || '', t = e.to_vin || '';
    // 8-char breakpoints = modern VINs (year letter + plant + 6 digits).
    // Shorter ones (classic Jaguar serials) cannot be compared → accept.
    if (f && f.length !== 8) f = '';
    if (t && t.length !== 8) t = '';
    if (f && f.charAt(1) !== serial.charAt(1)) return false;
    if (t && t.charAt(1) !== serial.charAt(1)) return false;
    var k = serialKey(serial);
    if (f && before(k, serialKey(f))) return false;
    if (t && before(serialKey(t), k)) return false;
    return true;
  }

  function pageOk(e, d) {
    var p = e.page || '';
    if (e.plant && d.plant && d.plant.toLowerCase().indexOf(e.plant.toLowerCase()) < 0) return false;
    var text = p + ' ' + (e.feat || '');
    if (d.wheelbase) {
      var swb = /SWB|Standard/i.test(d.wheelbase), lwb = /LWB|Long/i.test(d.wheelbase);
      if (/Standard Wheelbase/i.test(text) && lwb && !swb) return false;
      if (/Long Wheelbase/i.test(text) && swb && !lwb) return false;
    }
    if (d.engine) {
      var engines = p.match(/\d\.\dL?\s?[A-Za-z0-9 /\-\.]*?(?:Petrol|PETROL|Diesel|DIESEL|DSL|PHEV|MHEV|Electric|Hybrid)/g);
      if (engines && engines.length) {
        var mine = d.engine.toLowerCase();
        var hit = engines.some(function (x) {
          var s = x.replace(/\s+/g, ' ').trim().toLowerCase();
          return mine.indexOf(s) > -1 || s.indexOf(mine.split('(')[0].trim()) > -1;
        });
        if (!hit) return false;
      }
    }
    return true;
  }

  function fits(entries, d) {
    var hits = [];
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (e.cat !== d.cat) continue;
      if (!inRange(d.serial, e)) continue;
      if (!pageOk(e, d)) continue;
      hits.push(e);
    }
    return hits;
  }

  function uniq(arr) { var s = {}, o = []; arr.forEach(function (x) { if (x && !s[x]) { s[x] = 1; o.push(x); } }); return o; }

  function badge(card, label) {
    var old = card.querySelector('.vz-fit-badge');
    if (old) old.remove();
    if (!label) return;
    var b = document.createElement('div');
    b.className = 'vz-fit-badge';
    b.textContent = label;
    var info = card.querySelector('.card__information') || card;
    info.appendChild(b);
  }

  function strip(container, groups, d) {
    var old = container.querySelector('.vz-fit-strip');
    if (old) old.remove();
    var keys = Object.keys(groups).filter(function (k) { return groups[k].length > 1; });
    if (!keys.length) return;
    var el = document.createElement('div');
    el.className = 'vz-fit-strip';
    var h = document.createElement('p');
    h.className = 'vz-fit-strip__title';
    h.textContent = AR ? 'أي واحدة تناسب سيارتك؟ بعض القطع تختلف حسب تجهيزات السيارة:' : 'Which one is yours? Some parts differ by the car’s specification:';
    el.appendChild(h);
    var ul = document.createElement('ul');
    keys.forEach(function (k) {
      var li = document.createElement('li');
      li.innerHTML = '<b>' + k.replace(/[<>&]/g, '') + '</b>: ' + groups[k].map(function (x) { return x.replace(/[<>&]/g, ''); }).join(' · ');
      ul.appendChild(li);
    });
    el.appendChild(ul);
    var a = document.createElement('a');
    a.className = 'vz-fit-strip__wa';
    a.target = '_blank'; a.rel = 'noopener';
    var txt = (AR ? 'مرحباً VinZone، أي قطعة تناسب سيارتي؟ رقم الشاسيه: ' : 'Hi VinZone, which one fits my car? VIN: ') + d.vin;
    a.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(txt);
    a.textContent = AR ? 'اسألنا على واتساب — نؤكد لك القطعة الصحيحة' : 'Ask us on WhatsApp — we confirm the exact part';
    el.appendChild(a);
    var grid = container.querySelector('#product-grid');
    if (grid && grid.parentNode) grid.parentNode.insertBefore(el, grid); else container.insertBefore(el, container.firstChild);
  }

  function run() {
    var d = decode();
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    if (!d || !vehicleFiltered()) {
      container.querySelectorAll('[data-vz-card]').forEach(function (c) { badge(c, ''); });
      var s = container.querySelector('.vz-fit-strip'); if (s) s.remove();
      return;
    }
    var groups = {};
    var hidden = 0, shown = 0;
    container.querySelectorAll('[data-vz-card]').forEach(function (card) {
      var li = card.closest('.grid__item') || card;
      var node = card.querySelector('[data-vz-epc]');
      var entries = null;
      try { entries = node ? JSON.parse(node.textContent) : null; } catch (e) { entries = null; }
      if (!entries || !entries.length) { li.classList.remove('vz-fit-hidden'); shown++; return; } // no EPC data: never hide
      var hits = fits(entries, d);
      if (!hits.length) { li.classList.add('vz-fit-hidden'); badge(card, ''); hidden++; return; }
      li.classList.remove('vz-fit-hidden'); shown++;
      var opts = uniq(hits.map(function (h) { return h.opt; }));
      var label = opts.join(' / ') || card.getAttribute('data-vz-opt') || '';
      badge(card, label);
      var type = card.getAttribute('data-vz-type') || '';
      if (label && type) {
        groups[type] = groups[type] || [];
        if (groups[type].indexOf(label) < 0) groups[type].push(label);
      }
    });
    strip(container, groups, d);
    container.setAttribute('data-vz-vin-checked', hidden + '/' + (hidden + shown));
  }

  function observe() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || container.__vzVinObserved) return;
    container.__vzVinObserved = true;
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(run, 50);
    }).observe(container, { childList: true, subtree: true });
  }

  function init() { run(); observe(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  var css = document.createElement('style');
  css.textContent = [
    '.vz-fit-hidden{display:none !important}',
    '.vz-fit-badge{display:inline-block;margin:6px 0 0;padding:3px 8px;border-radius:6px;background:#eef3ff;color:#1f3a8a;font-size:12px;line-height:1.3}',
    '.vz-fit-strip{margin:0 0 16px;padding:12px 16px;border:1px solid #f0d9a8;border-radius:10px;background:#fff8e8;color:#4a3a12;font-size:14px}',
    '.vz-fit-strip__title{margin:0 0 6px;font-weight:600}',
    '.vz-fit-strip ul{margin:0 0 8px;padding-inline-start:18px}',
    '.vz-fit-strip li{margin:2px 0}',
    '.vz-fit-strip__wa{display:inline-flex;align-items:center;gap:6px;padding:8px 12px;border-radius:8px;background:#25D366;color:#fff !important;font-weight:600;text-decoration:none;font-size:13px}',
  ].join('\n');
  document.head.appendChild(css);
})();
